import { useQuery } from "@tanstack/react-query";

import { getNewsletterSubscribers } from "./newsletter-subscriber.services";

export const useGetNewsletterSubscribers = () => {
  return useQuery({
    queryKey: ["newsletterSubscribers"],
    queryFn: getNewsletterSubscribers,
  });
}